module.exports = __webpack_public_path__ + "static/media/icon-delete.f2649a96.svg";